<template>
    <div class="main-user-page container">
        <div class="row">
            <div class="col-md-4">
                <ApplicationsPanel/>
            </div>
            <div class="col-md-8">
                <AccountPanel/>
            </div>
        </div>
    </div>
</template>

<script>
import ApplicationsPanel from "@/pages/user/ApplicationsPanel.vue";
import AccountPanel from "@/pages/user/AccountPanel/AccountPanel.vue";

export default {
    name: "UserPage",
    components: {AccountPanel, ApplicationsPanel},
}
</script>

<style lang="scss">
.main-user-page {
    max-width: 1200px !important;
    margin: 100px auto 0 auto;
    padding-bottom: 50px;

    h2, h3 {
        font-size: 16px;
        font-weight: bold;
    }

}
</style>